









import {Vue, Component, Prop} from 'vue-property-decorator';
import ModalIframe from '@/components/iframe/ModalIframe.vue';
import OtpSettingIframe from '@/components/header/OtpSettingIframe.vue';


@Component({
  components: { ModalIframe, OtpSettingIframe },
})
export default class ManageAccountIframe extends Vue {
  @Prop() private showFlg!: boolean;
  private closePopup() {
    this.$emit('update:showFlg', false);
  }


  private get remoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/popup/admin-account-modify-form?' + queryString;
  }

  private showOtpSettingModal = false;

    private receiveMessage(e: MessageEvent) {
    if (e.data.closeAccountModifyForm) {
      this.closePopup()
      return;
    }

    if(e.data.openOtpSettingModal){
      this.showOtpSettingModal = true;
    }
  }

  mounted() {
    window.addEventListener('message', this.receiveMessage);
  }

  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  }
}
